import { ScreenerFilter } from '@toggle/toggle';
import { TFunction } from 'i18next';

export const getNewsSearchFilters = (t: TFunction): ScreenerFilter[] => [
  {
    key: 'provider',
    name: t('news:filters.provider'),
    visible: true,
    searchable: false,
    category: '',
    locked: true,
    dynamic: false,
    config: {
      multiselect: true,
      name: 'Provider',
      options: [
        {
          name: t('news:source_benzinga'),
          key: 'benzinga',
          value: {
            provider: 'benzinga',
          },
        },
        {
          name: t('news:source_mtn'),
          key: 'mtn',
          value: {
            provider: 'mtn',
          },
        },
      ],
    },
  },
  {
    key: 'date-picker',
    name: t('news:filters.dateRange'),
    visible: true,
    searchable: false,
    category: '',
    locked: true,
    dynamic: false,
    config: {
      multiselect: false,
      name: 'Date range',
      options: [
        {
          name: 'Today',
          key: 'today',
          value: {
            from: '',
            to: '',
          },
        },
        {
          name: 'Yesterday',
          key: 'yesterday',
          value: {
            from: '',
            to: '',
          },
        },
      ],
      custom: {
        key: 'date-range',
        name: 'Datepicker',
        custom: [],
      },
    },
  },
];
